<template>
  <HrWorkforcePanel title="Staff by District Fellowship" :note="recordedCount(divisionItems) + ' of ' + current.total + ' recorded'">
    <HrWorkforceLegend v-if="hasData(categoryLegend)" :items="categoryLegend" />
    <div class="hw-division-bars">
      <HrWorkforceBarRow
        v-for="row in divisionRows"
        :key="row.key"
        :name="row.name"
        :title="row.segments.map(item => item.label + ' ' + item.value).join(' · ')"
        :segments="row.segments"
        :scale="maxDivisionTotal"
        stacked
        :value="onlyCommaFormat(row.total)"
        :pill="percentLabel(row.total, current.total)"
        :pill-style="pctStyle(row)"
        name-width="200px"
      />
    </div>
  </HrWorkforcePanel>
</template>

<script setup>
import { computed, toRef } from 'vue'
import figureFormatter from '@/services/utils/figureFormatter'
import { hasData, notSpecifiedKey, pctStyle, percentLabel, rankedItems, recordedCount, toItems, useHrWorkforceItems } from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/hrWorkforce'
import HrWorkforcePanel from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/HrWorkforcePanel.vue'
import HrWorkforceLegend from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/HrWorkforceLegend.vue'
import HrWorkforceBarRow from '@/components/molecule/company/dashboard/dynamic-dashboard/hr-workforce/common/HrWorkforceBarRow.vue'

const props = defineProps({
  summary: { type: Object, required: true },
  current: { type: Object, required: true },
  labels: { type: Object, required: true }
})

const { onlyCommaFormat } = figureFormatter()
const { divisionItems, categoryLegend } = useHrWorkforceItems(toRef(props, 'current'), toRef(props, 'labels'), toRef(props, 'summary'))

const divisionCategoryCounts = (divisionKey) => {
  const counts = props.current.division_category || {}
  const prefix = divisionKey + '|'
  return Object.keys(counts)
    .filter(key => key.startsWith(prefix))
    .reduce((result, key) => ({ ...result, [key.slice(prefix.length)]: counts[key] }), {})
}

const divisionRows = computed(() => rankedItems(divisionItems.value).map(item => ({
  key: item.key,
  name: item.label,
  total: item.value,
  segments: toItems(divisionCategoryCounts(item.key), props.labels.categories)
})))

const maxDivisionTotal = computed(() => Math.max(1, ...divisionRows.value.filter(row => row.key !== notSpecifiedKey).map(row => row.total)))
</script>

<style scoped>
.hw-division-bars {
  max-height: 480px;
  overflow-y: auto;
  scrollbar-width: thin;
}
@media (max-width: 991px) {
  .hw-division-bars {
    max-height: 320px;
  }
}
</style>
